var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import cxs from 'cxs/component';
import { MessageType } from '../modules/UI/Model';
import Theme from 'Theme';
var UIMessage = /** @class */ (function (_super) {
    __extends(UIMessage, _super);
    function UIMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UIMessage.prototype.render = function () {
        var message = this.props.store.UI.message;
        if (!message)
            return null;
        var colors;
        if (message)
            colors =
                message.type === MessageType.Error
                    ? Theme.color.errorBackground
                    : Theme.color.warningBackground;
        return (React.createElement(Message, { type: message.type, style: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                textAlign: 'center',
                backgroundColor: colors,
            } }, message.text));
    };
    UIMessage = __decorate([
        inject('store'),
        observer
    ], UIMessage);
    return UIMessage;
}(Component));
export default UIMessage;
var Message = cxs('div')(function (_a) {
    var type = _a.type;
    return ({
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        padding: Theme.size.space[2],
        textAlign: 'center',
        textTransform: 'none',
        whiteSpace: 'pre',
        color: type === MessageType.Error
            ? Theme.color.errorText
            : Theme.color.warningText,
        backgroundColor: type === MessageType.Error
            ? Theme.color.errorBackground
            : Theme.color.warningBackground,
        zIndex: 1051,
        ':first-letter': {
            textTransform: 'uppercase'
        }
    });
});
Message.propTypes = {
    type: PropTypes.string
};



//////////////////
// WEBPACK FOOTER
// ./src/components/UIMessage.tsx
// module id = 1053
// module chunks = 0